import React, { createRef, useState, useEffect } from 'react'
import {
  Paper,
  Grid,
  CircularProgress,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  useTheme,
  useMediaQuery
} from '@material-ui/core'
import Cookie from 'js-cookie'
import { useHistory, Link } from 'react-router-dom'
import { DataGrid } from '@material-ui/data-grid'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import AddIcon from '@material-ui/icons/AddCircle'
import AddFlatIcon from '@material-ui/icons/Add'
import { useStore } from '../../context/Context'
import useStyles from './styles'
import { deleteMovie } from '../../api'
import ConfirmationDialog from '../ConfirmationDialog/ConfirmationDialog'

const MoviesDatabase = () => {
  const { isLoading, listMovies, setListMovies, setMessage } = useStore()
  const [open, setOpen] = useState(false)
  const [search, setSearch] = useState('')
  const history = useHistory()
  const classes = useStyles()
  const theme = useTheme()
  const matchXS = useMediaQuery(theme.breakpoints.down('xs'))
  const byDurationRef = createRef()
  const [yearFilter, setYearFilter] = useState('Not Set')
  const [ratingFilter, setRatingFilter] = useState('Not Set')
  const [data, setData] = useState([])
  const [deleteId, setDeleteId] = useState(null)

  useEffect(() => {
    setData(listMovies)
  }, [listMovies, setData])

  const handleSearchChange = (e) => {
    const value = e.target.value
    if (value) {
      const dataFound = listMovies.filter(movie => movie.title.toLowerCase().includes(value.toLowerCase()))
      setData(dataFound)
    } else {
      setData(listMovies)
    }
    setSearch(value)
  }

  const handleDelete = async (id) => {
    try {
      const token = await Cookie.get('token')
      await deleteMovie(id, token)
      const newData = listMovies.filter(movie => movie.id !== id)
      setListMovies(newData)
      setMessage(state => ({
        ...state,
        open: true,
        severty: 'success',
        msg: `${id} has just deleted`
      }))
    } catch (error) {
      console.log(error)
      setMessage(state => ({
        ...state,
        open: true,
        severty: 'error',
        msg: error.message,
        link: '/moviesDb'
      }))
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const year = yearFilter === 'Not Set' ? '' : yearFilter
    const rating = ratingFilter === 'Not Set' ? '' : ratingFilter
    const duration = parseInt(byDurationRef.current.value)
    const listMoviesMockup = listMovies.slice()
    const newListMovies = listMoviesMockup.filter(movie => {
      if (year) {
        if ((movie.year === year) === false) {
          return false
        }
      }

      if (rating !== '') {
        if ((movie.rating == rating) === false) {
          return false
        }
      }

      if (duration) {
        if ((movie.duration === duration) === false) {
          return false
        }
      }

      return true
    })
    setData(newListMovies)
  }

  const range = (start, stop, step = 1) => Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step)
  const yearRange = range(1900, new Date().getFullYear() + 1)
  const ratingRange = range(0, 11)

  const columns = [
    { field: 'id', headerName: 'No', width: matchXS ? 70 : 80 },
    { field: 'title', headerName: 'Title', width: matchXS ? 120 : 150, renderCell: (cellValues) => <Link className={classes.link} to={`/showMovie/${cellValues.id}`}>{cellValues.value}</Link> },
    { field: 'description', headerName: 'Description', width: 150, hide: matchXS ? true : false },
    { field: 'year', headerName: 'Release', width: 120, hide: matchXS ? true : false },
    { field: 'duration', headerName: 'Duration', width: 120, hide: matchXS ? true : false },
    { field: 'genre', headerName: 'Genre', width: 120, hide: matchXS ? true : false },
    { field: 'rating', headerName: 'Rating', width: 100, hide: matchXS ? true : false },
    { field: 'review', headerName: 'Review', width: 120, hide: matchXS ? true : false },
    {
      field: 'action', headerName: 'Action', width: matchXS ? 100 : 200, headerAlign: 'center', renderCell: (cellValues) => {
        return (
          <Grid container alignItems="center" justifyContent="center">
            <Button variant="contained" disableRipple className={classes.editButton} onClick={() => window.location.href = `/moviesDb/edit/${cellValues.id}`}>
              <EditIcon />
            </Button>
            <Button variant="contained" disableRipple className={classes.deleteButton} onClick={() => {
              setDeleteId(cellValues.id)
              setOpen(true)
            }}>
              <DeleteIcon />
            </Button>
          </Grid>
        )
      }
    }
  ]

  return (
    <main className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        {isLoading ? (
          <Grid container justifyContent="center" alignItems="center" className={classes.loading}>
            <CircularProgress />
          </Grid>
        ) : (
          <>
            <Grid container direction="column" spacing={matchXS ? 1 : 5}>
              <Grid item container justifyContent="space-between">
                {matchXS ? null : (
                  <Grid item container className={classes.filterForm} component="form" onSubmit={handleSubmit} justifyContent="flex-start" spacing={3} alignItems="center">
                    <Grid item>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="year-select-label">Year</InputLabel>
                        <Select
                          labelId="year-select-label"
                          id="year-select"
                          onChange={(e) => setYearFilter(e.target.value)}
                          value={yearFilter}
                          label="Year"
                        >
                          <MenuItem value="Not Set"><span className={classes.notset}>Not Set</span></MenuItem>
                          {yearRange.sort((a, b) => b - a).map(item => (
                            <MenuItem key={item} value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="rating-select-label">Rating</InputLabel>
                        <Select
                          labelId="rating-select-label"
                          id="rating-select"
                          onChange={(e) => setRatingFilter(e.target.value !== 'Not Set' ? parseInt(e.target.value) : 'Not Set')}
                          value={ratingFilter}
                          label="Year"
                        >
                          <MenuItem value="Not Set"><span className={classes.notset}>Not Set</span></MenuItem>
                          {ratingRange.map(item => (
                            <MenuItem key={item} value={item}>{item}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item>
                      <TextField variant="outlined" label="Duration (in minutes)" inputProps={{ ref: byDurationRef }} />
                    </Grid>
                    <Grid item>
                      <Button variant="contained" size="large" type="submit" className={classes.filterButton}>Filter</Button>
                    </Grid>
                    <Grid item>
                      <Button variant="outlined" size="large" type="reset" className={classes.resetButton} onClick={() => {
                        setYearFilter('Not Set')
                        setRatingFilter('Not Set')
                        setData(listMovies)
                      }}>Reset</Button>
                    </Grid>
                  </Grid>
                )}
                <Grid item>
                  {matchXS ? (
                    <Button
                      variant="contained"
                      onClick={() => history.push('/moviesDb/add')}
                      className={classes.buttonIcon}
                      startIcon={<AddFlatIcon />}
                    >
                      Add
                    </Button>
                  ) : (
                    <IconButton onClick={() => history.push('/moviesDb/add')}>
                      <AddIcon className={classes.addIcon} fontSize="large" />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
              <Grid item container>
                <Grid item>
                  <TextField label="Search by the title ..." value={search} onChange={handleSearchChange} variant="outlined" />
                </Grid>
              </Grid>
            </Grid>
            <div style={{ minHeight: 600, width: '100%' }}>
              <DataGrid
                autoHeight
                disableColumnFilter
                rows={data}
                columns={columns}
                className={classes.dataGrid}
                disableColumnMenu
                disableSelectionOnClick
                disableColumnSelector
                pageSize={6}
                rowsPerPageOptions={[6]}
              />
            </div>
          </>
        )}
      </Paper>
      <ConfirmationDialog open={open} setOpen={setOpen} onOk={() => handleDelete(deleteId)} />
    </main>
  )
}

export default MoviesDatabase
